import CityPageTemplate from "@/components/site/CityPageTemplate";

export default function FinanzberatungHamburg() {
  return (
    <CityPageTemplate
      city="Hamburg"
      slug="hamburg"
      intro="Als Hamburger Unternehmen kennen wir die lokalen Besonderheiten und beraten Dich mit echtem Heimvorteil."
      description="Unabhängige & digitale Finanzberatung für Hamburg: Altersvorsorge, ETF, Steueroptimierung und staatliche Förderungen. Kostenlose Erstberatung – 100% digital."
    />
  );
}
